import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { ApiService } from '../api.service';
import { TransactionService } from './transaction.service';
import { TransactionType, TransactionTypes } from './../models/transactions-enum';
import { Countries } from './../utils/countries-enum';
@Injectable({
  providedIn: 'root'
})
export class DealFileChecklistService {
  questionsDealFileChecklist = [
    {
      'identifier': 'conflict_of_interest',
      'label': 'Is there a conflict of interest?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    },
    {
      'identifier': 'government_entity',
      'label': 'Has a Government Entity checklist been completed?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false },
        { 'label': 'N/A', 'identifier': 'none', 'value': null }
      ],
      'link': {
        'identifier': 'complete_required_form',
        'label': '(complete <span class="link">required form</span> and upload)',
        'url': 'assets/docs/Govt-Entity-Checklist-May2024.docx'
      },
      'condition': null,
    },
    {
      'identifier': 'signed_agency_agreement',
      'label': 'Has the signed agency agreement been uploaded?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    },
    {
      'identifier': 'executed_lease_agreement',
      'label': 'Has the contract, executed lease or signed agreement been uploaded?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    },
    {
      'identifier': 'supporting_correspondence',
      'label': 'Has supporting correspondence been uploaded confirming the deal is unconditional/ settled in the invoiced month?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    },
    {
      'identifier': 'fee_calculation_approval',
      'label': 'Has the fee calculation approval been uploaded?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': 'true' },
        { 'label': 'No', 'identifier': 'no', 'value': 'false' },
        { 'label': 'N/A', 'identifier': 'none', 'value': 'n/a' }
      ],
      'condition': null,
    },
    {
      'identifier': 'supporting_documents_upload',
      'label': 'Has other supporting documents been uploaded (e.g. Trust Receipts, Company Checks, ABN Search)?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    },
    {
      'identifier': 'conjunctional_agreement_uploaded',
      'label': 'Has the conjunctional Agreement been uploaded?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': 'conjunctional_agent',
    }
  ];

  dsfQuestionsDealFileChecklist = [
    {
      'identifier': 'conflict_of_interest',
      'label': 'Is there a conflict of interest?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    },
    {
      'identifier': 'government_entity',
      'label': 'Has a Government Entity checklist been completed?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false },
        { 'label': 'N/A', 'identifier': 'none', 'value': null }
      ],
      'link': {
        'identifier': 'complete_required_form',
        'label': '(complete <span class="link">required form</span> and upload)',
        'url': 'assets/docs/Govt-Entity-Checklist-May2024.docx'
      },
      'condition': null,
    },
    {
      'identifier': 'signed_dsf_mandate',
      'label': 'Has the signed DSF Mandate been uploaded?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    },
    {
      'identifier': 'lender_agreement',
      'label': 'Has the Lender agreement been uploaded?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false },
        { 'label': 'N/A', 'identifier': 'none', 'value': null }
      ],
      'condition': null,
    },
    {
      'identifier': 'supporting_correspondence_settlement',
      'label': 'Has the supporting correspondence been uploaded confirming settlement?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    },
    {
      'identifier': 'fee_calculation_approval',
      'label': 'Has the fee calculation approval been uploaded?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': 'true' },
        { 'label': 'No', 'identifier': 'no', 'value': 'false' },
        { 'label': 'N/A', 'identifier': 'none', 'value': 'n/a' }
      ],
      'condition': null,
    },
    {
      'identifier': 'supporting_documents_upload',
      'label': 'Has other supporting documents been uploaded (e.g. Trust Receipts, Company Checks, ABN Search)?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    }
  ];

  questionsDealFileChecklistCountryBased = [{
    'country': 'NZL',
    'identifier': 'aml_clearance_or_screenshot',
    'label': 'Has an AML Clearance or screenshot from List of Customers with AML Clearance been uploaded?',
    'options': [
      { 'label': 'Yes', 'identifier': 'yes', 'value': true },
      { 'label': 'No', 'identifier': 'no', 'value': false }
    ],
    'condition': null,
  },
  {
    'country': 'AUS',
    'identifier': 'conjunctional_agreement_uploaded',
    'label': 'This fee includes an external conjunctional agent. Has the conjunctional agent checklist been completed and uploaded? (use Smartsheet link)',
    'options': [
      { 'label': 'Yes', 'identifier': 'yes', 'value': true },
    ],
    'link': {
      'identifier': 'COMPLETE_REQUIRED_FORM',
      'label': '(<span class="link">complete required form and upload</span>)',
      'url': 'https://app.smartsheet.com/b/form/2a58fc93f8fa4ff6b5bae6b6c83a44fe'
    },
    'condition': 'external_conjunctional_agent',
  },
  {
    'country': 'NZL',
    'identifier': 'conjunctional_agreement_uploaded',
    'label': 'This fee includes an external conjunctional agent. Has the conjunctional agent checklist been completed and uploaded? (use Smartsheet link)',
    'options': [
      { 'label': 'Yes', 'identifier': 'yes', 'value': true },
    ],
    'link': {
      'identifier': 'COMPLETE_REQUIRED_FORM',
      'label': '(<span class="link">complete required form and upload</span>)',
      'url': 'https://app.smartsheet.com/b/form/2a58fc93f8fa4ff6b5bae6b6c83a44fe'
    },
    'condition': 'external_conjunctional_agent',
  },

  ];

  questionsDealFileCheklistHongKong = [
    {
      'identifier': 'conflict_of_interest',
      'label': 'Is there a conflict of interest?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    }, {
      'identifier': 'go_diligence_summary',
      'label': 'Has the GO Diligence Summary form been uploaded?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'link': {
        'identifier': 'complete_required_form',
        'label': '(complete <span class="link">required form</span> and upload)',
        'url': 'assets/docs/GO Diligence Summary Form.doc'
      },
      'condition': null,
    }, {
      'identifier': 'go_related_client',
      'label': 'Is this a GO related client?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'link': {
        'identifier': 'complete_anti_corruption',
        'label': '(complete <span class="link">Anti-Corruption checklist</span> and upload)',
        'url': 'assets/docs/Anti-Corruption Checklist - GO related client (1).doc'
      },
      'condition': null,
    }, {
      'identifier': 'dealfilechecklist_upload',
      'label': 'Has the Deal file checklist been uploaded',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'link': {
        'identifier': 'complete_required_form',
        'label': '(complete <span class="link">required form</span> and upload)',
        'url': 'assets/docs/Deal File Checklist.docx'
      },
      'condition': null,
    }
  ];
  questionsDealFileCheklistTaiwan = [
    {
      'identifier': 'conflict_of_interest',
      'label': 'Is there a conflict of interest?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    }, {
      'identifier': 'go_diligence_summary',
      'label': 'Has the GO Diligence Summary form been uploaded?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'link': {
        'identifier': 'complete_required_form',
        'label': '(complete <span class="link">required form</span> and upload)',
        'url': 'assets/docs/GO Diligence Summary Form.doc'
      },
      'condition': null,
    }, {
      'identifier': 'go_related_client',
      'label': 'Is this a GO related client?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'link': {
        'identifier': 'complete_anti_corruption',
        'label': '(complete <span class="link">Anti-Corruption checklist</span> and upload)',
        'url': 'assets/docs/Anti-Corruption Checklist - GO related client (1).doc'
      },
      'condition': null,
    }, {
      'identifier': 'dealfilechecklist_upload',
      'label': 'Has the Deal file checklist been uploaded',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'link': {
        'identifier': 'complete_required_form',
        'label': '(complete <span class="link">required form</span> and upload)',
        'url': 'assets/docs/Deal File Checklist.docx'
      },
      'condition': null,
    }, {
      'identifier': 'fee_earner_confirmation',
      'label': 'Has the customer written confirmation on fee earned been uploaded?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    }, {
      'identifier': 'executed_lease_agreement',
      'label': 'Has the contract, executed lease or signed agreement been uploaded?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    }
  ];

  questionsDealFileChecklistJapan = [
    {
      'identifier': 'japan_signed_agency_agreement',
      'label': 'Has the signed agreement or purchase order been received? Please upload the relevant documents',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    },
    {
      'identifier': 'disclosure_statement',
      'label': 'Has the disclosure statement (Jyusetsu) been received? 〈Leases / Sales - Buyer〉Please upload the relevant documents',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': 'true' },
        { 'label': 'No', 'identifier': 'no', 'value': 'false' },
        { 'label': 'N/A', 'identifier': 'none', 'value': 'n/a' }
      ],
      'condition': null,
    },
    {
      'identifier': 'brokerage_agreement',
      'label': 'Has the brokerage agreement been received? 〈Sales〉Please upload the relevant documents',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': 'true' },
        { 'label': 'No', 'identifier': 'no', 'value': 'false' },
        { 'label': 'N/A', 'identifier': 'none', 'value': 'n/a' }
      ],
      'condition': null,
    },
    {
      'identifier': 'service_contract',
      // tslint:disable-next-line:max-line-length
      'label': 'Has the confirmation of service completion or delivery note been received? 〈Service Contract〉Please upload the relevant documents',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': 'true' },
        { 'label': 'No', 'identifier': 'no', 'value': 'false' },
        { 'label': 'N/A', 'identifier': 'none', 'value': 'n/a' }
      ],
      'condition': null,
    },
    {
      'identifier': 'brokerage_commission_allocation_memorandum',
      // tslint:disable-next-line:max-line-length
      'label': 'Has the calculation documents for fee allocation (Brokerage Commission Allocation Memorandum) been received? Please upload the relevant documents',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': 'true' },
        { 'label': 'No', 'identifier': 'no', 'value': 'false' },
        { 'label': 'N/A', 'identifier': 'none', 'value': 'n/a' }
      ],
      'condition': null,
    },
    {
      'identifier': 'japan_supporting_documents_upload',
      // tslint:disable-next-line:max-line-length
      'label': 'Has any other supporting documents been received? Please upload the relevant documents',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': 'true' },
        { 'label': 'No', 'identifier': 'no', 'value': 'false' },
        { 'label': 'N/A', 'identifier': 'none', 'value': 'n/a' }

      ],
      'link': {
        'identifier': 'revenue_recognition_policy_doc',
        'label': '(Refer to the <span class="link">REVENUE RECOGNITION POLICY</span>)',
        'url': 'assets/docs/RevenueRecognitionPolicy.xlsx'
      },
      'condition': null,
    },
    {
      'identifier': 'condition_precedent',
      'label': 'Is "condition precedent" included? If yes, please upload the evidence to confirm that the condition has been met',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': 'true' },
        { 'label': 'No', 'identifier': 'no', 'value': 'false' },
        { 'label': 'N/A', 'identifier': 'none', 'value': 'n/a' }

      ],
      'condition': null,
    },
    {
      'identifier': 'conflict_of_interest',
      'label': 'Is there a conflicts of interest?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }

      ],
      'condition': null,
    },
    {
      'identifier': 'japan_government_entity',
      'label': 'Is this a Government related client? If yes, please upload the FCPA check list ',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }

      ],
      'link': {
        'identifier': 'fcpa_checklist',
        'label': '(<span class="link">FCPA Checklist</span>',
        'url': 'assets/docs/腐敗行為防止チェックリスト Anti-corruption checklist ver201712.xlsx'

      },
      'condition': null,

    },
    {
      'identifier': 'revenue_recognition_policy',
      'label': 'Based on the above, have you confirmed that the transaction met the Revenue Recognition Policy?',
      'options': [
        { 'label': 'Yesconfirm', 'identifier': 'yesconfirm', 'value': true },
        { 'label': 'Noconfirm', 'identifier': 'noconfirm', 'value': false }

      ],
      'condition': null,
    }
  ];

  // Mortgage valuation MSA question for Singapore valuations
  mortgageValuationMsaQuestion = {
    'identifier': 'mortgage_valuation_msa',
    'label': 'Is this a Mortgage Valuation, and is there a Master Services Agreement (MSA) with the customer related to this invoice?',
    'options': [
      { 'label': 'Yes', 'identifier': 'yes', 'value': true },
      { 'label': 'No', 'identifier': 'no', 'value': false }
    ],
    'condition': null,
  };

  // dont change the order of questions
  questionsDealFileChecklistSingapore = [
    {
      'identifier': 'conflict_of_interest',
      'label': 'Is there a professional or employee conflict of interest?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    },
    {
      'identifier': 'intermediary_between_client_and_government_entity',
      'label': 'Did CBRE act as an intermediary between the client and government entity/official for this deal?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false },
      ],
      'condition': null,
    },
    {
      'identifier': 'government_entity',
      'label': 'Has the Government Entity (GO) AntiCorruption Checklist been completed?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false },
        { 'label': 'N/A', 'identifier': 'none', 'value': null }
      ],
      'link': {
        'identifier': 'go_listing',
        'label': '(<span class="link">GO Listing</span>)',
        'url': 'assets/docs/Listing-of-Government-Officials-(GO)-20190630.xlsm'
      },
      'condition': null,
    },
    {
      'identifier': 'signed_agency_agreement',
      'label': 'Has the signed agency agreement been uploaded?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    },
    {
      'identifier': 'executed_lease_agreement',
      'label': 'Has the contract, executed lease or signed agreement been uploaded?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    },
    {
      'identifier': 'supporting_correspondence',
      'label': 'Has supporting correspondence been uploaded confirming the deal is unconditional/ settled in the invoiced month?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    },
    {
      'identifier': 'fee_calculation_approval',
      'label': 'Has the fee calculation approval been uploaded?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': 'true' },
        { 'label': 'No', 'identifier': 'no', 'value': 'false' },
        { 'label': 'N/A', 'identifier': 'none', 'value': 'n/a' }
      ],
      'condition': null,
    },
    {
      'identifier': 'supporting_documents_upload',
      'label': 'Has other supporting documents been uploaded (e.g. KYC, customer due diligence)?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    },
    {
      'identifier': 'conjunctional_agreement_uploaded',
      // tslint:disable-next-line:max-line-length
      'label': 'Has the 3rd party co-agency/referrers agreement that contains confirmation of rates and fee payment arrangement been uploaded?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': 'conjunctional_agent',
    }
  ];

  questionDealFileChecklistIndia = [
    {
      'identifier': 'india_conflict_of_interest_check',
      'label': 'Conflicts of interest (COI) check completed?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'link': {
        'identifier': 'conflicts_of_interest_policy',
        'label': '(<span class="link">Conflicts of Interest Policy</span>)',
        'url': 'assets/docs/Conflict of interest Policy - India.pdf'
      },
      'condition': null,
    },
    {
      'identifier': 'government_entity',
      'label': 'Has a Government Entity checklist been completed?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false },
        { 'label': 'N/A', 'identifier': 'none', 'value': null }
      ],
      'link': {
        'identifier': 'complete_required_form',
        'label': '(complete <span class="link">required form</span> and upload)',
        'url': 'assets/docs/Government Checklist - India.docx'
      },
      'condition': null,
    },
    {
      'identifier': 'signed_agency_agreement',
      'label': 'Has the signed agency agreement been uploaded?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    },
    {
      'identifier': 'executed_lease_agreement',
      'label': 'Has the contract, executed lease or signed agreement been uploaded?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    },
    {
      'identifier': 'supporting_correspondence',
      'label': 'Has supporting correspondence been uploaded confirming the deal is unconditional/ settled in the invoiced month?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    },
    {
      'identifier': 'india_rei_standard_agency_agreement',
      'label': 'Have you used the REI standard agency agreement or CBRE standard template?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'info': {
        'identifier': 'india_rei_info_text',
        'label': 'please click the upload link at top of this box to attach Legal Counsel Approval'
      },
      'condition': null,
    },
    {
      'identifier': 'india_country_specific_company_check',
      'label': 'Have you attached the country specific completed company checks?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': 'true' },
        { 'label': 'No', 'identifier': 'no', 'value': 'false' },
        { 'label': 'N/A', 'identifier': 'none', 'value': 'n/a' }
      ],
      'condition': null,
    },
    {
      'identifier': 'india_client_name_abn_agreement_invoice_match',
      'label': 'Please confirm the Client Name and ABN on the agency agreement matches the same details on the invoice',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    },
    {
      'identifier': 'india_aml_screening_process',
      'label': 'Has the Anti-Money Laundering (AML) screening process been uploaded?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    },
    {
      'identifier': 'conjunctional_agreement_uploaded',
      'label': 'Has the conjunctional Agreement been uploaded?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': 'conjunctional_agent',
    }
  ];

  questionsDealFileCheklistChina = [
    {
      'identifier': 'signed_agency_agreement',
      'label': 'Has the signed agent agreement been uploaded?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    }, {
      'identifier': 'executed_lease_agreement',
      'label': 'Has the chopped contract, executed lease or signed agreement been uploaded?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    }, {
      'identifier': 'fee_calculation_approval',
      'label': 'Has the fee calculation approval from client been uploaded?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': 'true' },
        { 'label': 'No', 'identifier': 'no', 'value': 'false' }
      ],
      'condition': null,
    }, {
      'identifier': 'service_deliverable',
      'label': 'Has the evidence of service deliverables been uploaded?(e.g. bank receipt, deposit, Leasing Agreement, Sale Purchase Agreement, Service deliverable Acknowledgement from Client, Certificate of Property and etc.)',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': null,
    }, {
      'identifier': 'conjunctional_agreement_uploaded',
      'label': 'Has the conjunctional Agreement been uploaded?',
      'options': [
        { 'label': 'Yes', 'identifier': 'yes', 'value': true },
        { 'label': 'No', 'identifier': 'no', 'value': false }
      ],
      'condition': 'conjunctional_agent'
    }
  ];
  // additionalQuestionsDealFileChecklist = [
  //   {
  //     'identifier': 'billing_type',
  //     'label': 'What is the billing type?',
  //     'options': [
  //       { 'label': 'Singular event driven delivery (e.g., sale/lease/consultancy report)', 'identifier': 'Singular Event Driven Delivery', 'value': 'Singular Event Driven Delivery' },
  //       { 'label': 'Service delivery over a period of time (e.g., monthly/quarterly/retainer)', 'identifier': 'Service Delivery', 'value': 'Service Delivery' }
  //     ],
  //     'condition': 'additional',
  //   },
  //   {
  //     'identifier': 'agreement_and_proof_of_delivery',
  //     'label': 'Do you have an agreement and proof of delivery for the service to be invoiced that agrees to the period that the invoice will be recorded?',
  //     'options': [
  //       { 'label': 'Yes, I confirm', 'identifier': 'yes', 'value': true },
  //       { 'label': `No, I don't confirm. Do not bill`, 'identifier': 'no', 'value': false }
  //     ],
  //     'condition': 'additional',
  //   },
  //   {
  //     'identifier': 'support_for_the_fixed_fee',
  //     'label': 'If a fixed fee, have you received and uploaded (in Finishline) support for the fee that agrees to the amount per the invoice?',
  //     'options': [
  //       { 'label': 'Yes, I confirm', 'identifier': 'yes', 'value': true },
  //       { 'label': `Not applicable, variable fee`, 'identifier': 'no', 'value': false }
  //     ],
  //     'condition': 'additional',
  //   },
  //   {
  //     'identifier': 'support_for_the_variable_fee',
  //     'label': `If a variable fee, have you received and uploaded (in Finishline) the support for how the fee per the invoice was calculated, including support for the inputs
  //   used in the calculation?`,
  //     'options': [
  //       { 'label': 'Yes, I confirm', 'identifier': 'yes', 'value': true },
  //       { 'label': 'Not applicable, fixed fee', 'identifier': 'no', 'value': false }
  //     ],
  //     'condition': 'additional',
  //   }
  // ];

  constructor(
    private api: ApiService,
    private transactionService: TransactionService) { }

  getDealFileCheckList(transactionId: number) {
    return this.api.get(`/api/transactions/${transactionId}/dealchecklist/`).pipe(map(response => {
      return response;
    }));
  }

  saveDealFileCheckList(transactionId: number, dealFileCheckList) {
    return this.api.put(`/api/transactions/${transactionId}/dealchecklist/`, dealFileCheckList);
  }

  getQuestionsDealFileCheckList(transactionType: TransactionType, userCountry: Countries, conditionBased = null) {
    let questions = [], questionsByCountry, questionsByCondition;
    switch (transactionType) {
      case TransactionTypes.DSF:
        switch (userCountry) {
          case Countries.China:
            questions = this.questionsDealFileCheklistChina.filter(question => question.condition === null);
            break;
          case Countries.Taiwan:
            questions = this.questionsDealFileCheklistTaiwan.filter(question => question.condition === null);
            break;
          case Countries.India:
            questions = this.questionDealFileChecklistIndia.filter(question => question.condition === null);
            break;
          default:
            questions = this.dsfQuestionsDealFileChecklist.filter(question => question.condition === null);
            break;
        }
        break;
      case TransactionTypes.SALE:
      case TransactionTypes.LEASE:
      case TransactionTypes.CONSULTATION:
      case TransactionTypes.EXPENSE:
      case TransactionTypes.RESI:
        switch (userCountry) {
          case Countries.China:
            questions = this.questionsDealFileCheklistChina.filter(question => question.condition === null);
            break;
          case Countries.Hongkong:
            questions = this.questionsDealFileCheklistHongKong.filter(question => question.condition === null);
            break;
          case Countries.Taiwan:
            questions = this.questionsDealFileCheklistTaiwan.filter(question => question.condition === null);
            break;
          case Countries.Japan:
            questions = this.questionsDealFileChecklistJapan.filter(question => question.condition === null);
            break;
          case Countries.Singapore:
          case Countries.Thailand:
          case Countries.Philippines:
          case Countries.Vietnam:
          case Countries.Korea:
          case Countries.Indonesia:
            questions = this.questionsDealFileChecklistSingapore.filter(question => question.condition === null);
            break;
          case Countries.India:
            questions = this.questionDealFileChecklistIndia.filter(question => question.condition === null);
            break;
          default:
            questions = this.questionsDealFileChecklist.filter(question => question.condition === null);
            break;
        }
        break;
      case TransactionTypes.VALUATION:
        switch (userCountry) {
          case Countries.Korea:
            questions = this.questionsDealFileChecklist.filter(question => question.condition === null);
            break;
          case Countries.Singapore:
            questions = this.questionsDealFileChecklistSingapore.filter(question => question.condition === null);
            // Add mortgage valuation MSA question at the beginning for Singapore valuations
            questions = [this.mortgageValuationMsaQuestion, ...questions];
            break;  
          case Countries.India:
            questions = this.questionDealFileChecklistIndia.filter(question => question.condition === null);
            break;
        }
      default:
        break;
    }

    // Aggregate questions by country
    questionsByCountry = this.questionsDealFileChecklistCountryBased.filter(question => (question.country === userCountry && (conditionBased === question.condition || question.condition === null)));
    questions = [...questions, ...questionsByCountry];

    // Aggregate questions by condition
    
    if (conditionBased && ![Countries.Hongkong, Countries.Singapore, Countries.Japan, Countries.China, Countries.Taiwan].includes(userCountry)) {
      questionsByCondition = this.questionsDealFileChecklist.filter(question => question.condition === conditionBased);
      questions = [...questions, ...questionsByCondition];
    }

    if (conditionBased && transactionType === TransactionTypes.DSF &&
      [Countries.Hongkong, Countries.Singapore, Countries.Japan, Countries.China, Countries.Taiwan].includes(userCountry)) {
      questionsByCondition = this.questionsDealFileChecklist.filter(question => question.condition === conditionBased);
      questions = [...questions, ...questionsByCondition];
    }

    if (conditionBased && transactionType !== TransactionTypes.DSF && userCountry === Countries.Singapore) {
      questionsByCondition = this.questionsDealFileChecklistSingapore
        .filter(question => question.condition === conditionBased);
      questions = [...questions, ...questionsByCondition];
    }

    if (conditionBased && transactionType !== TransactionTypes.DSF && userCountry === Countries.Japan) {
      questionsByCondition = this.questionsDealFileChecklistJapan
        .filter(question => question.condition === conditionBased);
      questions = [...questions, ...questionsByCondition];
    }
    if (conditionBased && transactionType !== TransactionTypes.DSF && ([Countries.China, Countries.Taiwan].includes(userCountry))) {
      questionsByCondition = this.questionsDealFileCheklistChina
        .filter(question => question.condition === conditionBased);
      questions = [...questions, ...questionsByCondition];
    }

    if (transactionType === TransactionTypes.DSF && userCountry === Countries.Singapore) {
      // insert the question at 1st index
      questions = this.insert(questions, this.questionsDealFileChecklistSingapore[1], 1);
    }
    return questions;
  }

  insert(arr, val, index) {
    return index >= arr.length ? arr.concat(val)
      : arr.reduce((prev, x, i) => prev.concat(i === index ? [val, x] : x), []);
  }

}
